import React from "react";

import Button from "../../../Components/Button";
import CommonModal from "../../../Components/Modal";
import "../ToggleRlAssessmentsModal/style.scss";

export type WeeklyDigestToggleScope = "organization" | "all_sponsors";

interface ToggleWeeklyDigestModalProps {
  isOpen: boolean;
  toggle: () => void;
  organizationName?: string;
  isEnabling: boolean;
  onConfirm: () => void;
  loading?: boolean;
  nested?: boolean;
  /** Defaults to organization-scoped confirmation copy. */
  scope?: WeeklyDigestToggleScope;
}

const ToggleWeeklyDigestModal: React.FC<ToggleWeeklyDigestModalProps> = ({
  isOpen,
  toggle,
  organizationName,
  isEnabling,
  onConfirm,
  loading = false,
  nested = false,
  scope = "organization",
}) => {
  const title = isEnabling ? "Enable Weekly Digest" : "Disable Weekly Digest";
  const action = isEnabling ? "enable" : "disable";
  const orgLabel = organizationName || "this organization";

  const confirmationText =
    scope === "all_sponsors" ? (
      <>
        Are you sure you want to {action} Weekly Digest for{" "}
        <strong>all active executive sponsors</strong> in {orgLabel}?
      </>
    ) : (
      <>
        Are you sure you want to {action} Weekly Digest for{" "}
        <strong>{orgLabel}</strong>?
      </>
    );

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      size="md"
      nested={nested}
    >
      <div className="toggle-rl-assessments-modal">
        <p className="confirmation-text">{confirmationText}</p>

        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            loading={loading}
            variant={isEnabling ? "primary" : "danger"}
            onClick={onConfirm}
          >
            {isEnabling ? "Enable" : "Disable"}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default ToggleWeeklyDigestModal;
